import React, {Component} from 'react';
import { Link, NavLink } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

export default class Dropdown extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.state = {
      dropdownOpen: false
    };
  }

  toggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }

  onMouseEnter() {
    this.setState({dropdownOpen: true});
  }

  onMouseLeave() {
    this.setState({dropdownOpen: false});
  }

  render() {
    const {name, link, subMenu} = this.props.data;

    const dropdown = this.props.data.subMenu ? (
        <ul className={"HoverList"}>
            {subMenu.map((obj, idx)=>{
                return <li><p>
                            <HashLink to={obj.link}>{obj.name[this.props.lang]}</HashLink>
                        </p></li>
            })}
        </ul>
    ) : null;

    return (
      <li onMouseOver={this.onMouseEnter} onMouseLeave={this.onMouseLeave} isOpen={this.state.dropdownOpen}>
        <NavLink to={link}>{name[this.props.lang]}</NavLink>
        {this.state.dropdownOpen ? dropdown : null}
      </li>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Navigation/Dropdown/Dropdown.js